import { render, staticRenderFns } from "./Bytedance-Button.vue?vue&type=template&id=4b7992e1&scoped=true"
import script from "./Bytedance-Button.vue?vue&type=script&lang=js"
export * from "./Bytedance-Button.vue?vue&type=script&lang=js"
import style0 from "./Bytedance-Button.vue?vue&type=style&index=0&id=4b7992e1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7992e1",
  null
  
)

export default component.exports